/* eslint-disable no-underscore-dangle */
import './i18n/enable';
import './i18n';
// 组件预加载
import '@utils/preload/compPreload';

import '@/config/vue-config-runtime';
import 'moment/locale/zh-cn';
import '@utils/screen';
import '@tencent/ui-core/styles/deps';

import './config';
// 全局样式
// import './styles/uno.css';  // 下面再 require
import './styles/uicore-override.scss';
import './styles/global.scss';
import './styles/ant-design-react.less';

import { WujiTips } from '@tencent/wuji-source';
import lodash from 'lodash';
import Vue from 'vue';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';
import * as VueCompositionAPI from '@vue/composition-api';
import Antd, { Modal, notification } from 'ant-design-vue';

import runtimeModeRouter from '@/router/runtimeModeRouter';
import {
  getProjectRuntimeLessCode,
  defineProjectModules,
} from '@/utils/lessCode';
// 全局组件
import SysSpin from '@components/global/spin.vue';
import SysModal from '@components/modal/Modal.vue';
import PageLayout from '@components/pageLayout/PageLayout.vue';
import { preLoader } from '@loaders/runtimePreloader';
import utilsLoader from '@loaders/utils/loader';
import SysPagelet from '@pages/pagelet/index';
import SysPage from '@pages/pagelet/root';
import XyPageContainer from '@components/page/xy-page-container.vue';
import { Renderer, UcSlot, UcScopedSlot } from '@tencent/ui-core';
import { injectAegis } from '@utils/aegis';
import { proxyATagToWujiPage, useWujiScrollbar } from '@utils/browser';
import {
  registerAsyncComponentsByGivenComps,
  registerModuleLoader,
  getCompsList, initCompDeps,
} from '@utils/comps-loader';
import { dispatchCustomEvent } from '@utils/customEvent';
import getXyHeaders from '@utils/getXyHeaders';
import { loadXLSX } from '@utils/loadUtilScripts';
import { overwriteAntdMessage } from '@utils/message';
import { computeCurrentPageId } from '@utils/path';
import { getDefaultMixin } from '@utils/runtime-mixin';
import uploader from '@utils/upload';
import { CommonContext } from '@utils/global/api';
import { getUserId, getUserInfo } from '@utils/userInfo';
import { reLogin } from '@components/re-login-modal';
import pageletComponentModuleLoader from '@utils/comps-loader/special-module-loader/pagelet';
import { loadAmdModule } from '@utils/common';
import { mixinMemoryLeakRuntime } from '@utils/vue/initMemoryMixin';
import { getUiCore } from '@utils/getUiCore';
import wujiMessage from '@utils/wuji-message';
import initRuntimeHook from '@/hooks/runtimeHook';

import { initGlobalContext } from './context/globalContext';
// 此处需要保持引入，以注册到zeroDepStore
import store from './store/index';
import ucComponentPlugins from './ucComponentPlugins';
import getXyManagePathPrefix from './utils/getXyManagePathPrefix';
import { setupLogger } from './utils/logger';
import { loadScriptError } from './utils/loadScriptError';
import { defineCommonThirdPartyLibs } from './common_thirdparty_libs';
import { WujiScene, getProjectInfo, importDynamicDepdencies } from './dynamicSource';
import { UILibrary } from '@/consts/ui-library';
import getLanguageConfig from '@utils/i18n/load-language-config';
import { loginUtil } from './pages/modules/sso/login';
import { isOffline } from '@/utils/offline';

const loadDynamicSource = importDynamicDepdencies(WujiScene.Runtime);
window.dayjs = dayjs;
window.UcSlot = UcSlot;
window.UcScopedSlot = UcScopedSlot;

initRuntimeHook();

dayjs.extend(relativeTime);
dayjs.locale('zh-cn');

setupLogger();

useWujiScrollbar();


// ----themeExtractKeep.begin---
if (ANTDV_CUSTOM) {
  require(ANTDV_CUSTOM);
} else {
  require('./styles/antdv.default.less');
}
// ----themeExtractKeep.end----

// 保证 uno 样式不被 antd 覆盖
require('./styles/uno.css');

// 初始化组件initCompDeps
initCompDeps();

Vue.use(wujiMessage);
Vue.use(Antd);
Vue.use(VueCompositionAPI.default);

// 内存泄露相关
mixinMemoryLeakRuntime(Vue);

Vue.component('UcRenderer', Renderer);
Vue.component('UcExprInput', async () => {
  const UICore = await getUiCore();
  return UICore.ExprInput;
});
Vue.component('UcExprInputCompletionProvider', async () => {
  const UICore = await getUiCore();
  return UICore.ExprInputCompletionProvider;
});
Vue.component('UcAnyInput', async () => {
  const UICore = await getUiCore();
  return UICore.AnyInput;
});

/**
 * 注册全局组件
 */
Vue.component('PageLayout', PageLayout);
Vue.component('WSysModal', SysModal);
Vue.component('WSysPage', SysPage);
Vue.component('WSysPagelet', SysPagelet);
Vue.component('WSysSpin', SysSpin);
Vue.component('XyPageContainer', XyPageContainer);

// 挂载全局变量，这部分有优化空间，部分依赖应该用compsloader或者external来处理，尽量不用window来达到复用的目的
window.lodash = lodash;
// window.UICore = UICore;
window.vue = Vue;
window.Vue = Vue;
window['ant-design-vue'] = Antd;
window.utilsLoader = utilsLoader;
window['@vue/composition-api'] = VueCompositionAPI;
window.xy_runtime_utils = {
  store,
  getXyHeaders,
  getXyManagePathPrefix,
  loadXLSX,
  loadAmdModule,
  reLogin,
  uploader,
  getUserInfo,
};
window.wujiScriptError = loadScriptError;

// 注册特殊组加载逻辑
registerModuleLoader('pagelet', pageletComponentModuleLoader);

// 异步注册组件库组件
registerAsyncComponentsByGivenComps([
  'public-w-dept-rtx-select',
  'public-w-cherry-markdown',
]);

defineCommonThirdPartyLibs();
overwriteAntdMessage();

// 废弃方法: 需要时应该使用 import { Modal } from 'ant-design-vue'; + Modal.confirm
Vue.prototype.$aConfirm = Vue.prototype.$confirm;

window.ucComponentPlugins = ucComponentPlugins;

const loadIcon = () => {
  const icons = ['public-w-icon-show-new', 'public-w-icon-show:antd'];

  const iconLoadPromise = getCompsList({
    compsKey: icons,
    register: true,
  }).then((components) => {
    let proto = Object.getPrototypeOf(Vue.options.components);
    while (proto) {
      if (proto['public-w-icon-show-new']) {
        // eslint-disable-next-line no-loop-func
        icons.forEach((icon) => {
          proto[icon] = components[icon].comp;
        });
      }
      proto = Object.getPrototypeOf(proto);
    }
  });

  icons.forEach((icon) => {
    Vue.component(icon, {
      created() {
        iconLoadPromise.then(() => {
          this.$vnode.context.$forceUpdate();
        });
      },
      render(h) {
        return h('span', {
          style: {
            width: 'var(--xy-custom-sidebar-font-size-icon)',
            height: 'var(--xy-custom-sidebar-font-size-icon)',
            'margin-right': '8px',
          },
        });
      },
    });
  });
};
/**
 * runtime Vue实例入口
 */
export default (async function () {
  loadIcon();
  const { project, projectId, env, branch, aiAdvanceConfig } = await getProjectInfo();

  console.log('runtime', project, projectId, env, branch, aiAdvanceConfig);

  const router = await runtimeModeRouter({ projectId, env, branch, aiAdvanceConfig });
  initGlobalContext(router);
  proxyATagToWujiPage(router);

  // 页面配置 数据源预加载
  const pageId = computeCurrentPageId(router);
  preLoader.load({ projectId, pageId, env, branch });

  if (!isOffline()) {
    store.dispatch('rbac/fetchPermissions', { projectId, env });
  }

  const mode = 'runtime';
  // 这个类的构造函数依赖上面store里dispatch的两个事件!
  const w = new CommonContext({ mode });
  window.w = w;

  if (!isOffline()) {
    injectAegis({ rtx: getUserId(), project, projectId, mode: 'runtime' });
  }

  await defineProjectModules(project, { w });
  const defaultMixin = getDefaultMixin({ project, env, mode, w });
  const projectMixin = getProjectRuntimeLessCode(project, { w });

  await loadDynamicSource;

  const useTDesign = project.componentHubUILibrary === UILibrary.tdesign;

  const { antdLocale, tdesignLocale } = await getLanguageConfig(useTDesign);

  const instanceFactory = () => new Vue({
    router,
    store,
    el: '#ui-root',
    provide() {
      return {
        w,
      };
    },
    /* 注入应用的 LessCode */
    mixins: projectMixin ? [defaultMixin, projectMixin] : [defaultMixin],
    // 抛出实例化前自定义事件
    async beforeCreate() {
      // 注入全局实例变量
      Vue.prototype.$app = this;
      // 统一提示器，可自由配置样式
      Vue.prototype.$tips = new WujiTips(project, this);
      dispatchCustomEvent('wuji:beforeCreate');
    },
    // 抛出实例化后挂载前自定义事件
    async created() {
      dispatchCustomEvent('wuji:created');
    },
    // 抛出挂载后自定义事件
    async mounted() {
      if (window.wujiFrontEndOptions.onLogin) {
        loginUtil.preloadModal();
      }

      const event = 'allDataSourcesReadyForCache';
      // 首屏数据源就绪后触发拉取缓存数据(在 w-container 组件中触发)
      this.$once(event, () => {
        // 异步加载页面列表数据
        store.dispatch('runtime/initPageList', { projectId, env, branch });
      });
      // 5秒后触发事件(防止数据源就绪事件未触发)
      setTimeout(() => this.$emit(event), 10 * 1000);

      dispatchCustomEvent('wuji:mounted');
    },
    render: (h) => {
      const defaultLayout = h(
        'a-config-provider',
        {
          attrs: {
            locale: antdLocale,
          },
        }, [h('router-view')],
      );

      if (useTDesign) return h('t-config-provider', {
        props: {
          globalConfig: tdesignLocale,
        },
      }, [defaultLayout]);
      return defaultLayout;
    },
  });

  /* eslint-disable no-underscore-dangle */
  if (window.__POWERED_BY_WUJIE__) {
    let instance;
    window.__WUJIE_MOUNT = () => {
      instance = instanceFactory();
      window.xy_vue_instance = instance;
      return instance;
    };
    window.__WUJIE_UNMOUNT = () => {
      instance.$destroy();
      window?.$message?.destroy();
      notification.destroy();
      Modal.destroyAll();
    };
    if (window.__WUJIE.mount) {
      window.__WUJIE.mount();
    } else {
      window.__WUJIE_MOUNT();
    }
  } else {
    const instance = instanceFactory();
    window.xy_vue_instance = instance;
    return instance;
  }
}());

if (module.hot) {
  module.hot.accept();
}
